import { acceptHMRUpdate, defineStore } from 'pinia'

export const useTeamStore = defineStore('team', {
  state: () => ({
    id: null,
    slug: null,
    name: null,
    abbr: null,
    fullName: null,
    seoName: null,
    sportId: null,
    imgSrc: null,
    country: null,
    venue: null,

    // Related entities 
    featured: null,
    season: null,
    league: null,
    
    // Custom data
    logo: null,
    nickname: '{fix_nickname}',
    manager: '{fix_manager}',
    colors: null,
    theme: {},
    
    // Debugging
    // _raw: null,
  }),

  actions: {
    async addTeam(data) {
      this.id = data?.id || data?.team?.id
      this.slug = data?.team?.slug
      this.name = data?.team?.name
      this.fullName = data?.team?.fullName
      this.seoName = data?.team?.seoName
      this.abbr = data?.team?.abbr
      this.sportId = data?.team?.sportId
      this.imgSrc = data?.team?.imgSrc
      this.country = data?.team?.country
      this.venue = data?.team?.venue

      // Related entities 
      this.featured = data?.featured
      this.season = data?.season
      this.league = data?.league
      
      // Custom data
      this.logo = data?.team?.logo
      this.colors = data?.team?.colors
      this.theme = data?.team?.theme

      // RAW data for debugging
      // this._raw = data
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTeamStore, import.meta.hot))
}
